import { PartialSerializer3a1dmo3dlumfz as PartialSerializer } from './PartialSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (PartialSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var PartialClass;
function Partial() {
  if (PartialClass === VOID) {
    class $ {
      constructor(parts) {
        var tmp;
        if (parts === VOID) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        } else {
          tmp = parts;
        }
        parts = tmp;
        this.parts_1 = parts;
      }
      toString() {
        return 'Partial(parts=' + toString(this.parts_1) + ')';
      }
      hashCode() {
        return hashCode(this.parts_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Partial()))
          return false;
        if (!equals(this.parts_1, other.parts_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Partial', Partial, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    PartialClass = $;
  }
  return PartialClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Partial as Partial3s6az7bcg7e88,
  Companion_instance as Companion_instance8en83qldk4o3,
};
//endregion

//# sourceMappingURL=Partial.mjs.map
